/**
 * Interface nhãn (Tag) — đồng bộ với response API /business/tag/all.
 * Mỗi tag thuộc 1 fanpage hoặc 1 nhóm (groupId).
 * UI dùng code (không phải id) để so khớp với conversation.tagIds.
 */
export interface ITag {
  id: string; // ID nhãn
  code: string; // Mã nhãn
  name: string; // Tên hiển thị
  backgroundColor: string; // Màu nền (#HEX)
  color: string; // Màu chữ (#HEX)
  fanpageId?: string; // ID trang sở hữu (null nếu là tag doanh nghiệp)
  businessId?: string; // ID doanh nghiệp (null nếu là tag theo page)
  groupId?: string; // ID nhóm tag (nếu là tag nhóm)
  shortcut?: string; // Phím tắt gán nhãn
  order?: number; // Thứ tự sắp xếp
  status?: number; // Xem TAG_STATUS
  typeBlock?: number | null; // 1: chặn tin nhắn, 2: chặn tất cả
  createdTime?: number; // Timestamp (giây)
}

/** Trạng thái tag */
export const TAG_STATUS = {
  ACTIVE: 1,    // Hoạt động — hiển thị everywhere, cho phép gắn/gỡ
  INACTIVE: 2,  // Tạm ngưng — hiển thị nếu đã gắn, không cho gắn mới
  REMOVE: 3,    // Đã xóa — không load, không hiển thị
} as const;
export type TagStatusValue = typeof TAG_STATUS[keyof typeof TAG_STATUS];

/**
 * Interface response từ API /business/tag/all
 * API V2 trả danh sách trong `data.result` (V1 cũ là `items`).
 */
export interface ITagAllResponse {
  result: ITag[];
  pageGroupMapping?: Record<string, string>; // Map pageId => groupId
}
